import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import axios from "axios";

const PortfolioContext = createContext(null);

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export function PortfolioProvider({ children }) {
  const [state, setState] = useState({ loading: true, visible: false, items: [] });

  const load = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/portfolio`);
      setState({ loading: false, visible: Boolean(data?.visible), items: Array.isArray(data?.items) ? data.items : [] });
    } catch {
      setState({ loading: false, visible: false, items: [] });
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const value = useMemo(() => ({
    loading: state.loading,
    visible: state.visible,
    items: state.items,
    refresh: load,
    imageUrl: (id) => `${API}/portfolio/items/${id}/image`,
  }), [state, load]);

  return <PortfolioContext.Provider value={value}>{children}</PortfolioContext.Provider>;
}

export function usePortfolio() {
  const ctx = useContext(PortfolioContext);
  if (!ctx) throw new Error("usePortfolio must be used within PortfolioProvider");
  return ctx;
}
